module.exports = __webpack_public_path__ + "static/media/enabledOffenseIcon.a32b1120.svg";